import {searchInputs} from "../Search/Input/SearchInputs";

export let MenuProps = {
    menuPosition: {
        default: 'blog_footer'
    },
    searchInput:{
        options: Object.keys(searchInputs),
        default: 'mSearchInput200'
    }
}